module.exports = __webpack_public_path__ + "img/websites.a8f51bdc.jpg";